import { Typography } from '@montugroup/design-system';
import { TextContainer } from './States.styles';

export const ScriptAwaitingReview = () => {
  return (
    <TextContainer data-testid="pharmacist-escript-script-awaiting-review">
      <Typography variant="subtitle1" fontWeight={600} sx={(theme) => ({ marginBottom: theme.spacing(6) })}>
        Review in progress
      </Typography>
      <Typography>We are checking if uMeds can supply this medication for your customer.</Typography>
      <Typography>An email and/or SMS have been sent to the customer to sign up with uMeds.</Typography>
      <Typography>We will update the customer as soon as the review is complete.</Typography>
    </TextContainer>
  );
};
